import { render } from "./ProgrammaLavoroDetail.vue?vue&type=template&id=90d35046&scoped=true"
import script from "./ProgrammaLavoroDetail.vue?vue&type=script&lang=js"
export * from "./ProgrammaLavoroDetail.vue?vue&type=script&lang=js"

import "./ProgrammaLavoroDetail.vue?vue&type=style&index=0&id=90d35046&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1769522087380908112/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d35046"]])

export default __exports__